import React from 'react'
import Grid from '../layout/grid'

export default props => (
    <Grid cols={props.cols}>

        <div class="form-group">
            <label for="exampleFormControlTextarea1">{props.label}</label>
            <textarea {...props.input} class="form-control" id="exampleFormControlTextarea1" rows="3"
                placeholder={props.placeholder}
                readOnly={props.readOnly}
                type={props.type}></textarea>
        </div>

    </Grid>
)


// WEBPACK FOOTER //
// ./src/common/form/textArea.jsx